import { render, staticRenderFns } from "./overGoodsList.vue?vue&type=template&id=58b9640c&scoped=true&"
import script from "./overGoodsList.vue?vue&type=script&lang=js&"
export * from "./overGoodsList.vue?vue&type=script&lang=js&"
import style0 from "./overGoodsList.vue?vue&type=style&index=0&id=58b9640c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58b9640c",
  null
  
)

export default component.exports